<template>

  <vx-card>
    <div class="vx-row">
      <div class="vx-col w-1/2 pt-3">
        <h5> {{ $t('class-section.vdo-set-info') }} </h5>
      </div>

<!--      <div class="vx-col w-1/2">
        <vs-dropdown class="cursor-pointer float-right" vs-trigger-click>
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">{{ $t('general.actions') }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item @click="onCreateClick">
                <span class="flex items-center">
                  <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-4 w-4"/>
                  <span>{{ $t('general.add') }}</span>
                </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="onEditClick">
                <span class="flex items-center">
                  <feather-icon class="mr-2" icon="EditIcon" svgClasses="h-4 w-4"/>
                  <span>{{ $t('general.edit') }}</span>
                </span>
            </vs-dropdown-item>


          </vs-dropdown-menu>
        </vs-dropdown>
      </div>-->

    </div>

    <vs-divider/>

    <!-- Display Data -->
    <div v-if="!showEditForm">
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <ValidationProvider :name="$t('vdo-set.vdo-sets')" rules="required" v-slot="{ errors }">
            <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      :disabled="isUploading"
                      :name="$t('vdo-set.vdo-sets')"
                      :options="vdoSets"
                      @input="onVdoSetChange"
                      class="w-full mb-1"
                      label="code"
                      selectOnTab
                      v-model="vdoSetInfo.selectedVdoSet">

              <template #selected-option="{ code }">
                {{ code }}
              </template>
              <!--option list-->
              <template v-slot:option="option">
                {{ option.code + ' ' + option.description}}
              </template>

            </v-select>
            <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
          </ValidationProvider>
        </div>
      </div>

      <!--<div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2">
        <span class="flex items-center">
          <feather-icon icon="BookOpenIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
          <span class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-units-qty') }}</span>
        </span>
        </div>
        <div class="vx-col sm:w-1/2 text-right">
        <span :class="totalVdoUnits === 0 ? 'text-danger':''">
          {{ totalVdoUnits }}
        </span>
        </div>
      </div>-->
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2">
        <span class="flex items-center">
          <feather-icon icon="VideoIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
          <span
            class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-qty') }}</span>
        </span>
        </div>
        <div class="vx-col sm:w-1/2 text-right">
        <span :class="totalVdoQty === 0 ? 'text-danger':''">
          {{ totalVdoQty }}
        </span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
        <span class="flex items-center">
          <feather-icon icon="FilmIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
          <span
            class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-total-length') }}</span>
        </span>
        </div>
        <div class="vx-col sm:w-1/2 text-right">
        <span :class="totalVdoLength === '00:00:00' ? 'text-danger':''">
          {{ totalVdoLength }}
        </span>
        </div>
      </div>
    </div>

    <!-- Edit Data -->
    <div v-else>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <label class="text-sm">{{$t('vdo-set.vdo-set-code')}}</label>
          <vs-input v-model="form.vdoSetInput.code"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <label class="text-sm">{{$t('vdo-set.description')}}</label>
          <vs-textarea rows="3"
                       v-model="form.vdoSetInput.description"/>
        </div>
      </div>
      <!-- Actions Button -->
      <div class="vx-row pt-2">
        <div class="vx-col w-full">
          <vs-button :disabled="local.isProcessing || isUploading"
                     @click.prevent="onSaveClick">
            {{ $t('general.save') }}
          </vs-button>

          <vs-button @click.prevent="onCancelClick" class="ml-2" color="warning"
                     type="border">
            {{ $t('general.cancel') }}
          </vs-button>
        </div>
      </div>
    </div>

  </vx-card>

</template>

<script>
  import {state, setEmptyVdoSetTopicForm} from '../data';
  import vSelect from 'vue-select';
  import {secondToHHMMSSFormat} from "@/utils/data";
  import {showStateNotification} from "@/utils/notification";
  import {confirmSave} from "@/utils/dialogs";

  import VdoSet from '@/store/modules/vdo-set/vdo-set/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.VdoSet) state.registerModule(`VdoSet`, VdoSet);

  const {
    mapActions: mapVdoSetActions,
  } = createNamespacedHelpers(`VdoSet`);

  const {
    mapFields: mapVdoSetFields,
  } = createHelpers({
    getterType: `VdoSet/getField`,
    mutationType: `VdoSet/updateField`,
  });

  export default {
    components: {
      vSelect
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        vdoSetEdit: state.local.vdoSetEdit,
        vdoSetInfo: state.local.vdoSetInfo,
        vdoSetUnitEdit: state.local.vdoSetUnitEdit,
        form: state.local.vdoSetInfo.form,

        showEditForm: false,
      }
    },
    computed: {
      ...mapVdoSetFields({vdoSetProcessing: 'processing', vdoSetSuccess: 'success', vdoSetError: 'error'}),
      isUploading() {
        return this.local.isUploading;
      },
      totalVdoUnits() {
        let totalVdoUnit = 0;
        if (this.vdoSetInfo.selectedVdoSet) {
          totalVdoUnit = this.vdoSetInfo.selectedVdoSet.vdoSetUnits.length
        }
        return totalVdoUnit;
      },
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.vdoSetInfo.selectedVdoSet) {
          totalVdoLength = secondToHHMMSSFormat(this.vdoSetInfo.selectedVdoSet.totalVdoLength);
        }
        return totalVdoLength;
      },
      totalVdoQty() {
        let totalVdoQty = 0;
        if (this.vdoSetInfo.selectedVdoSet) {
          this.vdoSetInfo.selectedVdoSet.vdoSetUnits.forEach(vdoUnit => {
            if (vdoUnit.vdoSetTopics && vdoUnit.vdoSetTopics.length > 0) {
              vdoUnit.vdoSetTopics.forEach(vdoTopic => {
                totalVdoQty += vdoTopic.vdoStreamPath ? 1 : 0;
              })
            }
          });
        }
        return totalVdoQty;
      },
      vdoSets() {
        return this.vdoSetEdit.courseOutline ? this.vdoSetEdit.courseOutline.vdoSets : [];
      },
    },
    watch: {
      vdoSetProcessing(data) {
        this.local.isProcessing = data;
      },
      vdoSetSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      vdoSetError: async function (data) {
        showStateNotification(this.$vs, data);
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapVdoSetActions({
        getVdoSetsByFilter: 'getVdoSetsByFilter',
        addVdoSet: 'addVdoSet',
        updateVdoSet: 'updateVdoSet',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onCreateClick() {
        this.form.id = null;
        this.form.degreeId = this.vdoSetEdit.courseOutline.degree.id;
        this.form.courseOutlineId = this.vdoSetEdit.courseOutline.id;
        this.form.subjectGroupId = this.vdoSetEdit.courseOutline.subjectGroup.id;
        this.form.subjectId = this.vdoSetEdit.courseOutline.subject.id;
        this.form.teacherId = this.vdoSetEdit.courseOutline.teacher.id;

        this.form.vdoSetInput.subjectCode = this.vdoSetEdit.courseOutline.subject.code;
        this.form.vdoSetInput.teacherCode = this.vdoSetEdit.courseOutline.teacher.code;
        this.form.vdoSetInput.totalVdoLength = 0;
        this.form.vdoSetInput.code = this.vdoSetEdit.courseOutline.subject.code + '-'
          + String(this.vdoSetEdit.courseOutline.vdoSets.length + 1).padStart(3, '0');
        this.form.vdoSetInput.description = '';

        this.showEditForm = true;
      },
      onEditClick() {
        //deep copy
        let editData = JSON.parse(JSON.stringify(this.vdoSetInfo.selectedVdoSet));

        //set from selected vdoSet
        this.form.id = editData.id;
        this.form.vdoSetInput.code = editData.code;
        this.form.vdoSetInput.description = editData.description;

        this.showEditForm = true;
      },
      async onSaveClick() {
        confirmSave(this.$vs, this.saveVdoSet, this.form);
      },
      onCancelClick() {
        this.toggleEditForm();
      },
      onVdoSetChange() {
        if (this.vdoSetInfo.selectedVdoSet.vdoSetUnits && this.vdoSetInfo.selectedVdoSet.vdoSetUnits.length > 0) {
          this.vdoSetUnitEdit.selectedVdoSetUnit = this.vdoSetInfo.selectedVdoSet.vdoSetUnits[0];
        }
        setEmptyVdoSetTopicForm();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async saveVdoSet(payload) {
        let result;
        if (!payload.id) {
          //insert
          let insertPayload = {
            degreeId: payload.degreeId,
            courseOutlineId: payload.courseOutlineId,
            subjectGroupId: payload.subjectGroupId,
            subjectId: payload.subjectId,
            teacherId: payload.teacherId,
            vdoSetInput: {
              subjectCode: payload.vdoSetInput.subjectCode,
              teacherCode: payload.vdoSetInput.teacherCode,
              totalVdoLength: 0,
              code: payload.vdoSetInput.code,
              description: payload.vdoSetInput.description,
            },
          }

          result = await this.addVdoSet(insertPayload);
        } else {
          //update
          let editPayload = {
            id: payload.id,
            code: payload.vdoSetInput.code,
            description: payload.vdoSetInput.description,
          };

          result = await this.updateVdoSet(editPayload);
        }

        if (result) {
          this.updateListAfterSave(payload, result);
          this.toggleEditForm();
        }
      },
      updateListAfterSave(payload, result) {
        //deep copy so we can mutate data
        result = JSON.parse(JSON.stringify(result));
        if (!payload.id) {
          //add new item to list
          this.vdoSetEdit.courseOutline.vdoSets.push(result);

        } else {
          //update list
          const index = this.vdoSetEdit.courseOutline.vdoSets.findIndex(item => item.id === result.id);
          this.vdoSetEdit.courseOutline.vdoSets[index] = result;
        }
        //set selected item
        this.vdoSetInfo.selectedVdoSet = result;

        //set vdoSetUnit selected item
        this.onVdoSetChange();

      },
      toggleEditForm() {
        this.showEditForm = !this.showEditForm;
      },
    },
  }

</script>

<style scoped>

</style>
